import axios from '../../axios/index.js'
import store from '../../../store/store.js'


export default {
    uploadPhoto(UserId, Title, Description, IsPublic, Type, FileName, file) {
        //console.log('paso sa request')
        return axios.post('/api/photo/upload', { params: {
            UserId : UserId,
            Title : Title,
            Description : Description,
            IsPublic : IsPublic,
            Type : Type,
            FileName : FileName,
            file : file
        }})
    },
    deletePhoto(photoId){
        return axios.delete(`/api/photo/${photoId}`)
    }
    
}